import { graphql } from "@/graphql/codegen"

graphql(`
  fragment GlTransactionRowAccountFields on GlAccount {
    glAccountId
    number
    subNumber
    title
  }
`)

graphql(`
  fragment GlTransactionRowFields on GlTransactionRow {
    glTransactionRowId
    glTransactionId
    glAccountId
    type
    amount
    createdOn
    glAccount {
      ...GlTransactionRowAccountFields
    }
  }
`)

graphql(`
  fragment GlTransactionBaseFields on GlTransaction {
    glTransactionId
    description
    note
    transactionDate
    as400SyncStatus
    status
    reason
    recurringId
    referenceNumber
    hasDocuments
    isReadOnly
    createdOn
    updatedOn
    createdByUser {
      firstName
      lastName
    }
    updatedByUser {
      firstName
      lastName
    }
    reverseTransaction {
      referenceNumber
      reason
      createdOn
      createdByUser {
        firstName
        lastName
      }
    }
  }
`)
